// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  BUTTON: '[data-fragment="FaqCollapse.button"]',
  TEXT_CONTAINER: '[data-fragment="FaqCollapse.textContainer"]',
  TEXT: '[data-fragment="FaqCollapse.text"]'
};

class FaqCollapse extends WebComponent {
  constructor(props) {
    super(props);
    this.isOpen = false;
    this.collapse = this.collapse.bind(this);
  }

  didMount() {
    this.button = this.element.querySelector(fragments.BUTTON);
    this.textContainer = this.element.querySelector(fragments.TEXT_CONTAINER);
    this.text = this.element.querySelector(fragments.TEXT);

    this.button.addEventListener('click', this.collapse);
  }

  collapse() {
    if (this.element.classList.contains(this.props.openClass)) {
      this.element.classList.remove(this.props.openClass);
      this.textContainer.style.maxHeight = '0';
    }
    else {
      this.element.classList.add(this.props.openClass);
      this.textContainer.style.maxHeight = 'initial';
    }
  }
}


FaqCollapse.defaultProps = {
  openClass: 'campfire-accordion--open',
}

export default FaqCollapse;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FaqCollapse.js